import {createReducer, PayloadAction} from '@reduxjs/toolkit';
import {Country, ICountry} from '../../types/models/Country';
import {SETTINGS} from './Actions';
import {AdminUserSettings} from '../../types/views/AdminUserSettings';
import {AgeRange} from '../../types/views/AgeRange';
import { DeviceType } from '../../types/common/DeviceType';
import { ContentItemType } from '../../types/common/ContentItemType';
import { Platform } from '../../types/common/Platform';
import {ContentItemCategory} from "../../types/models/ContentItemCategory";


export interface ISessionState {
    settingsLoading: boolean | false;
    settingsError: string | undefined;
    settingsInitialized: boolean;
    countries: Country[] | undefined;
    fileTags: string[] | undefined;
    fileSystemTags: string[] | undefined;
    countriesLoading: boolean;
    countriesError: string | undefined;
    ageRanges: AgeRange[] | undefined;
    deviceTypes: DeviceType[] | undefined;
    platforms: Platform[] | undefined;
    contentItemTypes: ContentItemType[] | undefined;
    contentItemCategories: ContentItemCategory[] | undefined;
    contentItemCategoryCreating: boolean | false;
    contentItemCategoryError: string | undefined;
}

const initialState: ISessionState = {
    settingsLoading: false,
    settingsInitialized: false,
    settingsError: undefined,
    fileTags: [],
    fileSystemTags: [],
    countries: [],
    countriesLoading: false,
    countriesError: undefined,
    ageRanges: [],
    deviceTypes: [],
    platforms: [],
    contentItemTypes: [],
    contentItemCategories: [],
    contentItemCategoryCreating: false,
    contentItemCategoryError: undefined,
}

const settingsReducer = createReducer(initialState, {
    [SETTINGS.LOAD]: (state) => {
        state.settingsLoading = true;
        state.settingsError = undefined;
    },
    [SETTINGS.LOADED]: (state, action: PayloadAction<AdminUserSettings>) => {
        const { ageRanges } = action.payload;
        state.settingsInitialized = true;
        state.settingsLoading = false;
        state.ageRanges = ageRanges;
        state.deviceTypes = action.payload.deviceTypes;
        state.platforms = action.payload.platforms;
        state.contentItemTypes = action.payload.contentItemTypes;
        state.contentItemCategories = action.payload.contentItemCategories;
    },
    [SETTINGS.ERROR]: (state, action: PayloadAction<string>) => {
        state.settingsInitialized = true;
        state.settingsLoading = false;
        state.settingsError = action.payload;
    },
    [SETTINGS.LOCALITIES_LOAD]: (state) => {
        state.countriesLoading = true;
        state.countriesError = undefined;
    },
    [SETTINGS.LOCALITIES_LOADED]: (state, action: PayloadAction<ICountry[]>) => {
        state.countriesLoading = false;
        state.countries = action.payload;
    },
    [SETTINGS.LOCALITIES_ERROR]: (state, action: PayloadAction<string>) => {
        state.countriesLoading = false;
        state.countriesError = action.payload;
    },
    [SETTINGS.CONTENT_CATEGORY_CREATE]: (state, action: PayloadAction<string>) => {
        state.contentItemCategoryCreating = true;
        state.contentItemCategoryError = undefined;
    },
    [SETTINGS.CONTENT_CATEGORY_CREATED]: (state, action: PayloadAction<ContentItemCategory>) => {
        const categories = state.contentItemCategories ? [...state.contentItemCategories] : [];
        categories.push(action.payload);
        state.contentItemCategories = categories;
        state.contentItemCategoryCreating = false;
    },
    [SETTINGS.CONTENT_CATEGORY_CREATE_ERROR]: (state, action: PayloadAction<string>) => {
        state.contentItemCategoryCreating = false;
        state.contentItemCategoryError = action.payload;
    },
});

export default settingsReducer;